export default `
.bike-card {
	width: 9.46cm;
	height: 4.87cm;
	border: 2px solid black;
    display: inline-block;
    vertical-align: top;
}
.bike-card-info {
	margin-left: 1.5cm;
	margin-top: 0.50cm;
}
.page:not(:last-child):after {
	page-break-after: always;
	page-break-inside: avoid;
}
.table-border, table.table-border th, table.table-border td {
	border: 1px solid black;
	text-align: center;
	padding: 2px 5px;
	border-collapse: collapse;
}
body {
	font-family: Arial
}
.text-left {
	text-align: left !important;
}
.text-center {
	text-align: center;
}
.text-right {
	text-align: right;
}
.text-no-wrap {
	white-space: nowrap;
}
.font-weight-bold {
	font-weight: bold;
}
.mx-auto {
	margin-left: auto;
	margin-right: auto;
}
.col-6 {
    float: left;
	width: 49%;
	border: 1px solid black;
	margin: 0.05cm;
}
page {
	background: white;
	display: block;
	margin: 0 auto;
}
page[size="A4"] {
	width: 21cm;
}
page[size="A4"][layout="landscape"] {
	width: 29.7cm;
	height: 21cm;
}
page[size="A3"] {
	width: 29.7cm;
	height: 42cm;
}
page[size="A3"][layout="landscape"] {
	width: 42cm;
	height: 29.7cm;
}
page[size="A5"] {
	width: 14.8cm;
	height: 21cm;
}
page[size="A5"][layout="landscape"] {
	width: 21cm;
	height: 14.8cm;
}
.room-bill {
	height: 570px;
}
.room-bill td {
	font-size: 15px;
}
`